import React, { useState } from "react";
import {
  ContentModal,
  Content,
  ButtonDone,
  SizeImgRating,
  ModalContainer,
  IconContent,
} from "./FeedbackComponent.styled";
import PortalModal from "../../Portals";
import ThumbUpAltOutlinedIcon from "@material-ui/icons/ThumbUpAltOutlined";

const FeedbackComponent = ({
  arrayImageRating,
  eventName,
  handleSendFeedback,
  eventRating,
}) => {
  const [comments, setComments] = useState("");
  return (
    <PortalModal>
      <ModalContainer>
        <ContentModal>
          <IconContent>
            <ThumbUpAltOutlinedIcon />
          </IconContent>
          <Content>
            <p>
              {`We would love to have your feedback for the event ${eventName}`}
            </p>
            <div style={{ margin: "1em auto" }}>
              <SizeImgRating>{arrayImageRating}</SizeImgRating>
            </div>
            <div style={{ width: "100%" }}>
              <textarea
                name="textarea"
                rows="6"
                style={{ width: "100%" }}
                placeholder="Type your observations here"
                value={comments}
                onChange={(e) => setComments(e.target.value)}
              ></textarea>
            </div>
          </Content>
          <ButtonDone
            disabled={eventRating === 0}
            onClick={() => {
              handleSendFeedback(comments);
              setComments("");
            }}
          >
            Send
          </ButtonDone>
        </ContentModal>
      </ModalContainer>
    </PortalModal>
  );
};

export default FeedbackComponent;
